import React from "react";

// export function RansomwareSkullIcon() {
// 	return (
// 		<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
// 			<path d="M12 2C7.03 2 3 5.58 3 10c0 2.39 1.19 4.53 3.08 6.06L5 22h14l-1.08-5.94C19.81 14.53 21 12.39 21 10c0-4.42-4.03-8-9-8zm-3.5 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm7 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM8.5 15c.83.94 2.17 1.5 3.5 1.5s2.67-.56 3.5-1.5H8.5z" />
// 		</svg>
// 	);
// }

export function ViewScreenEyeIcon() {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M12 5C7 5 2.73 8.11 1 12.5 2.73 16.89 7 20 12 20s9.27-3.11 11-7.5C21.27 8.11 17 5 12 5zm0 11.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z" />
		</svg>
	);
}

export function WindowsPlatformIcon() {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M3 4.5 10.5 3.4V11H3V4.5zm0 13 7.5 1.1V12.5H3v5zm9.5 1.2L21 20.1V12.5h-8.5v6.2zm0-11.7L21 3.9V11h-8.5V7z" />
		</svg>
	);
}

export function ApplePlatformIcon() {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M16.365 1.43c0 1.14-.42 2.19-1.17 3-.78.84-2.04 1.49-3.2 1.4-.14-1.09.45-2.25 1.15-3.01.82-.88 2.26-1.53 3.22-1.39zM20.88 17.2c-.57 1.31-.85 1.9-1.58 3.06-1.02 1.58-2.46 3.55-4.24 3.57-1.59.02-2-.95-3.73-.97-1.73-.02-2.14.99-3.73.97-1.78-.02-3.28-2.12-4.3-3.7-2.95-4.55-3.27-9.88-1.44-12.7 1.28-1.97 3.3-3.12 5.2-3.12 1.93 0 3.15 1.12 4.75 1.12 1.54 0 2.48-1.12 4.69-1.08 1.6.03 3.3.93 4.57 2.38-4.02 2.19-3.36 7.88.67 9.47z" />
		</svg>
	);
}
